var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1626 20.9126H3.5376C2.36354 20.9126 1.4126 19.9617 1.4126 18.7876V10.2876C1.4126 9.11354 2.36354 8.1626 3.5376 8.1626H14.1626C15.3367 8.1626 16.2876 9.11354 16.2876 10.2876V18.7876C16.2876 19.9617 15.3367 20.9126 14.1626 20.9126Z",
    stroke: "#3E4145",
    strokeWidth: 1.59375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8501 16.7582V14.0063",
    stroke: "#3E4145",
    strokeWidth: 1.59375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41357 12.646C9.72477 12.9572 9.72477 13.4617 9.41357 13.7729C9.10237 14.0841 8.59782 14.0841 8.28662 13.7729C7.97542 13.4617 7.97542 12.9572 8.28662 12.646C8.59782 12.3348 9.10237 12.3348 9.41357 12.646",
    stroke: "#3E4145",
    strokeWidth: 1.59375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6001 8.1626V6.0376V6.0376C4.6001 3.69054 6.50304 1.7876 8.8501 1.7876V1.7876C11.1972 1.7876 13.1001 3.69054 13.1001 6.0376V6.0376V8.1626",
    stroke: "#3E4145",
    strokeWidth: 1.59375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.e8c6befe1c77cff623a1b05b671ac96a.svg";
export { ForwardRef as ReactComponent };